import './App.css';
import React from 'react';

function App() {
  return (
    <div className="App">
      <div className="content">
        <div className="header-container">
          <header>
            <h1>Nasır Kırmızı Portfolio</h1>
            <nav>
              <a href="#about">About</a>
              <a href="#projects">Projects</a>
              <a href="#technologies">Technologies</a>
              <a href="#contact">Contact</a>
            </nav>
          </header>
        </div>

        <main>
          <div className="main-content">
            <section id="about">
              <h2>About Me</h2>
              <ul>
                <li>Nasır Kırmızı</li>
                <li>Turkey</li>
                <li>Fullstack Developer · Focused on Blockchain &amp; Web3</li>
                <li>Graduated from Uludağ University, Computer Programming</li>
                <li>Building on-chain apps with smart contracts, exploring Web3, AI &amp; open-source</li>
              </ul>
            </section>

            <section id="projects">
              <h2>Projects</h2>
              <p>Projects I have worked on throughout my development journey:</p>
              <div className="project-grid">
                <div className="project-card">
                  <a href="https://carrotcollector.com/" target="_blank" rel="noopener noreferrer">Carrot Collector</a>
                  <p>A 2D infinite runner game built on the Linea (EVM) blockchain. Features a Solidity smart contract for on-chain game logic, hosted via Railway &amp; Supabase. Built for the <a href="https://x.com/BunnyOnLinea" target="_blank" rel="noopener noreferrer">@BunnyOnLinea</a> project.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/Blockchain_Kahoot" target="_blank" rel="noopener noreferrer">Blockchain Kahoot</a>
                  <p>On-chain Kahoot-style quiz dApp built on the Sui blockchain. Features a Move smart contract for game logic, Soulbound Token (SBT) rewards &amp; a React frontend.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/echoblade-Hackathon" target="_blank" rel="noopener noreferrer">Echoblade Hackathon</a>
                  <p>Hackathon project built with TypeScript.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/Chaintree" target="_blank" rel="noopener noreferrer">Chaintree</a>
                  <p>Blockchain-based project with a live demo available.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/Stellar_Workshop" target="_blank" rel="noopener noreferrer">Stellar Workshop</a>
                  <p>Workshop &amp; experiments on the Stellar blockchain.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/csharp_tutorial" target="_blank" rel="noopener noreferrer">C# Tutorial</a>
                  <p>A self-study guide documenting my C# learning journey.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/Cofdelux_v01" target="_blank" rel="noopener noreferrer">CofDelux</a>
                  <p>Table &amp; bill tracking app for cafes and restaurants, built with C#.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/DataStructures-and-Algorithms" target="_blank" rel="noopener noreferrer">Data Structures &amp; Algorithms</a>
                  <p>C# algorithm &amp; data structure examples and implementations.</p>
                </div>
                <div className="project-card">
                  <a href="https://github.com/NasirKrmzz/GiT-TUTORiAL" target="_blank" rel="noopener noreferrer">Git Tutorial</a>
                  <p>Turkish reference guide for Git commands and workflows.</p>
                </div>
              </div>
            </section>

            <section id="technologies">
              <h2>Technologies</h2>
              <ul>
                <li><strong>Languages:</strong> C#, TypeScript, JavaScript, Move (Sui), Solidity</li>
                <li><strong>Blockchain / Web3:</strong> Sui, Linea (EVM), Stellar, Smart Contracts, Soulbound Tokens</li>
                <li><strong>Frontend:</strong> React, HTML, CSS</li>
                <li><strong>Tools &amp; Other:</strong> Git, Unity (2D), LeetCode / DSA</li>
              </ul>
            </section>

            <section id="contact">
              <h2>Contact / Social</h2>
              <ul>
                <li>Email (<a href="mailto:nasirkrmzz@protonmail.com" target="_blank" rel="noopener noreferrer">nasirkrmzz@protonmail.com</a>)</li>
                <li>GitHub (<a href="https://github.com/NasirKrmzz" target="_blank" rel="noopener noreferrer">NasirKrmzz</a>)</li>
                <li>LinkedIn (<a href="https://www.linkedin.com/in/nasır-kırmızı-a9a244313" target="_blank" rel="noopener noreferrer">Nasır Kırmızı</a>)</li>
                <li>X (<a href="https://x.com/0xNadolinn" target="_blank" rel="noopener noreferrer">0xNadolinn</a>)</li>
              </ul>
            </section>
          </div>
        </main>

        <footer>
          <span>© Nasır Kırmızı 2026, inspired by the original | <a href="https://sdomi.pl/">Sdomi</a></span>
        </footer>
      </div>
    </div>
  );
}

export default App;
